var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 2",
    d: "M20 10.1078C20.6118 10.1078 21.1078 9.61183 21.1078 9C21.1078 8.38817 20.6118 7.89218 20 7.89218V10.1078ZM1.21665 8.21665C0.784019 8.64928 0.784019 9.35072 1.21665 9.78335L8.2668 16.8335C8.69943 17.2661 9.40086 17.2661 9.83349 16.8335C10.2661 16.4009 10.2661 15.6994 9.83349 15.2668L3.5667 9L9.83349 2.7332C10.2661 2.30057 10.2661 1.59914 9.83349 1.16651C9.40086 0.733874 8.69943 0.733874 8.2668 1.16651L1.21665 8.21665ZM20 7.89218L2 7.89218V10.1078L20 10.1078V7.89218Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.a71a08fb9d01c1b7a62cc2414425d9c5.svg";
export { ForwardRef as ReactComponent };